enum AccessibilityCriterion {
    ASSISTANCE_DOGS_PERMITTED = "assistance-dogs-permitted",
    BRIGHT_LIGHTING = "bright-lighting",
    CROWDED = "crowded",
    HEADPHONE_AREA = "headphone-area",
    INTERACTIVE = "interactive",
    LEVEL_TERRAIN = "level-terrain",
    LOW_LIGHTING = "low-lighting",
    NOISY = "noisy",
    PUSHCHAIR_ACCESSIBLE = "pushchair-accessible",
    QUIET = "quiet",
    REMOTE = "remote",
    ROUGH_TERRAIN = "rough-terrain",
    STEEP_TERRAIN = "steep-terrain",
    SMELLY = "smelly",
    STEPS = "steps",
    UNEVEN_TERRAIN = "uneven-terrain",
    WHEELCHAIR_ACCESSIBLE = "wheelchair-accessible"
}

export default AccessibilityCriterion